module.exports = __webpack_public_path__ + "static/logo-white-135eb5ea47b9fbd5a8606e5adce75611.svg";